module.exports = __webpack_public_path__ + "img/help_outline-24px.7a0e054f.svg";